import { ColorWidget } from './widgets/ColorWidget';

export function ColorField({ effectiveValue, onValue }) {
  return <ColorWidget value={effectiveValue} onChange={onValue} />
}
